export default "__VITE_ASSET__yMzvw6sA__"